module.exports = __webpack_public_path__ + "static/media/initiatives.ca44ab22.svg";